import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $imageWrapper: this.el.querySelector('.mosaic-image-gallery__masonry')
    };

    this.images = this.el.dataset.images.split(',');
    this.indexMap = ['a', 'b', 'c', 'd', 'e', 'f'];
    this.fillImages();
  }

  shuffle(array) {
    let currentIndex = array.length,  randomIndex;

    while (currentIndex !== 0) {
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]];
    }

    return array;
  }

  buildImages() {
    const shuffledImages = this.shuffle(this.images).slice(0, 6);
    let imagesTemplate = '';

    shuffledImages.forEach((image, index) => {
      imagesTemplate += `
        <li class="mosaic-image-gallery__masonry__item mosaic-image-gallery__masonry__item--${this.indexMap[index]}">
          <picture class="image-v2__wrapper">
            <source media="(max-width:677px)" srcset="${image}">
            <img src="${image}" alt="random" class="image-v2 image-v2--rounded" width="840" height="473">
          </picture>
        </li>
      `;
    });

    return imagesTemplate;
  }

  showImage($image) {
    $image.classList.add('mosaic-image-gallery__masonry__item--scaled');
  }

  fillImages() {
    const imagesTemplate = this.buildImages();
    this.dom.$imageWrapper.innerHTML = imagesTemplate;
    const $images = this.dom.$imageWrapper.querySelectorAll('.mosaic-image-gallery__masonry__item');
    const $shuffledImages = /*this.shuffle(*/$images/*)*/;

    setTimeout(() => {
      $shuffledImages.forEach(($image, index) => {
        setTimeout(() => {
          this.showImage($image);
        }, 50 * index);
      })
    }, 100);
  }
}

export default Module;
